export default {
  TimesPluralization: '次 | 次',
  PointsPluralization: '分 | 分'
}
